export default __webpack_public_path__ + "static/media/NeutralPotion.315779fb.svg";